// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"Tasks_notificationsContainer__1oxGc","title":"Tasks_title__hUHTb","item":"Tasks_item__2yERJ"};